namespace Nobox {

    @Serenity.Decorators.registerEditor()
    export class SupervisorEditor extends Serenity.ServiceLookupEditorBase<ToolLookupEditorOptions, Administration.UserRow> {
        

        public _lastRequest: JQueryXHR;
        public option: ToolLookupEditorOptions;
        private _stateNM: string;
        private _stateID: number;
        public response: Serenity.ListResponse<Administration.UserRow>;

        constructor(hidden: JQuery, opt: ToolLookupEditorOptions) {
            super(hidden, opt);
            this.option = opt;
        }

        public destroy(): void {
            super.destroy();
        }

        public getService(): string {
            return "Administration/User";
        }
  
        public getServiceUrl() {
            return "/Services/Administration/User/List"
        }

        public getItemKey(item: Administration.UserRow): string {
            return item.DisplayName;
        }

        public getItemText(item: Administration.UserRow): string {
            return item.DisplayName;
        }

        public getTypeDelay(): number {
            return 500;
        }

        protected asyncSearch(query: Serenity.Select2SearchQuery, results: (result: Serenity.Select2SearchResult<Administration.UserRow>) => void): Serenity.Select2SearchPromise {
            var opt1 = this.getServiceCallOptions(query, results) as Serenity.ServiceOptions<Serenity.ServiceResponse>;
            opt1.request.EqualityFilter = { Roles :["2"] };
            return Q.serviceCall(opt1);
        }

        public GetIncludeColumns(): string[] {
            return [Administration.UserRow.Fields.UserId, Administration.UserRow.Fields.DisplayName];
        }

    }
    interface ToolLookupEditorOptions extends Serenity.ServiceLookupEditorOptions {
        ToolEditor: string;
    }

}